import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaw = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 8,
			cy: 6.5,
			rx: 1.9,
			ry: 2.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 16,
			cy: 6.5,
			rx: 1.9,
			ry: 2.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 3.8,
			cy: 11.5,
			rx: 1.8,
			ry: 2.3
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20.2,
			cy: 11.5,
			rx: 1.8,
			ry: 2.3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 11.5c-2.6 0-4.4 2.2-5.4 4-.9 1.7-.4 4 1.6 4.3 1.3.2 2.5-.6 3.8-.6s2.5.8 3.8.6c2-.3 2.5-2.6 1.6-4.3-1-1.8-2.8-4-5.4-4z" })
	]
});
export default SvgPaw;
